<script setup lang="ts">
import {computed, provide, ref, watch} from 'vue';
import {breakpointsTailwind, useBreakpoints} from '@vueuse/core';
import {DialogOverlay} from "radix-vue";

const props = defineProps({
  modelValue: Boolean
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(props.modelValue);

const breakpoints = useBreakpoints(breakpointsTailwind);
const smallerThanLg = computed(() => breakpoints.smaller('md').value);

watch(() => props.modelValue, (newVal) => {
  isOpen.value = newVal;
});

watch(isOpen, (newVal) => {
  emit('update:modelValue', newVal);
});

// Open and close methods for external control
const open = () => {
  isOpen.value = true;
};

const close = () => {
  isOpen.value = false;
};

// Providing `closeModal` for consistent handling
provide('closeModal', close);

</script>

<template>
  <slot name="trigger" :open="open"></slot>
  <Dialog v-model:open="isOpen" v-if="!smallerThanLg" class="bg-black">
    <DialogContent>
      <slot></slot>
    </DialogContent>
  </Dialog>
  <Drawer v-model:open="isOpen" v-if="smallerThanLg">
    <DrawerContent>
      <slot></slot>
    </DrawerContent>
  </Drawer>
</template>
